// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2qn_V","right":"styles_right__PTXhc"};